'use client';

import Link from 'next/link';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { GoLocation } from 'react-icons/go';
import { MdOutlineEmail, MdOutlinePhoneInTalk } from 'react-icons/md';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';

export function ContactCards({ generalLayout }: { generalLayout: GeneralLayout['data'] }) {
  const isDesktop = useBreakpoint('sm');

  const data = [
    {
      icon: <MdOutlineEmail size={isDesktop ? 48 : 40} className="text-primary" />,
      name: 'Napíšte nám',
      value: generalLayout?.contact?.email,
      href: `mailto:${generalLayout?.contact?.email}`,
    },
    {
      icon: <MdOutlinePhoneInTalk size={isDesktop ? 48 : 40} className="text-primary" />,
      name: 'Zavolajte nám',
      value: generalLayout?.contact?.phone,
      href: `tel:${generalLayout?.contact?.phone}`,
    },
    {
      icon: <GoLocation size={isDesktop ? 48 : 40} className="text-primary" />,
      name: 'Navštívte nás',
      value: `${generalLayout?.contact?.address}, ${generalLayout?.contact?.postcode} ${generalLayout?.contact?.city}`,
      href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${generalLayout?.contact?.address}, ${generalLayout?.contact?.postcode} ${generalLayout?.contact?.city}`)}`,
    },
  ];

  return (
    <section className={cn('custom-section', 'py-6 sm:py-8 md:py-10 lg:py-12')}>
      <div className={cn('custom-container', 'grid grid-cols-1 gap-3 md:grid-cols-3 lg:gap-6')}>
        {data.map(card => (
          <ContactCard card={card as any} key={card.name} />
        ))}
      </div>
    </section>
  );
}

function ContactCard({
  card,
}: {
  card: { icon: React.ReactNode; name: string; value: string; href: string };
}) {
  return (
    <Link
      href={card?.href}
      prefetch={false}
      target="_blank"
      className="flex w-full flex-col items-start justify-start gap-3 rounded-[20px] border p-3 transition-all hover:bg-border/25 sm:gap-4 sm:p-4 lg:p-6"
    >
      {card.icon}
      <Heading title={card.name} tag="h5" />
      <Heading title={card.value} tag="h4" className={{ title: 'text-primary' }} />
    </Link>
  );
}
